import React, { createContext, useState, useEffect } from 'react';
import { logOut } from '../_shared/commonFunction';
import { useLocation, useNavigate } from 'react-router-dom';
import { globalAlert } from '../actions/commonActions';


export const InactivityContext = createContext(null);

export const InactivityProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const history = { push: (to) => navigate(to) };
  const [inactiveTime, setInactiveTime] = useState(0);
  const [timeoutValue, setTimeoutValue] = useState(60 * 60 * 1000); // Default 30 minutes

  useEffect(() => {
    // Only start timer for admin routes
    if (!location?.pathname?.startsWith('/admin')) {
      return;
    }

    console.log(location?.pathname);

    let idleTimer = null;

    const resetTimer = () => {
      clearTimeout(idleTimer);
      setInactiveTime(0);
      
      idleTimer = setTimeout(() => {
        setInactiveTime(timeoutValue);
      }, timeoutValue);
    };

    // Reset timer on user activity
    const handleActivity = () => {
      console.log("activity encountered", timeoutValue);
      resetTimer();
    };

    // Listen for user activity
    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('keypress', handleActivity);
    document.addEventListener('click', handleActivity);
    document.addEventListener('scroll', handleActivity);
    document.addEventListener('touchstart', handleActivity);

    // Initialize timer
    resetTimer();

    // Cleanup event listeners
    return () => {
      document.removeEventListener('mousemove', handleActivity);
      document.removeEventListener('keypress', handleActivity);
      document.removeEventListener('click', handleActivity);
      document.removeEventListener('scroll', handleActivity);
      document.removeEventListener('touchstart', handleActivity);
      clearTimeout(idleTimer);
    };
  }, [timeoutValue]);

  // Handle timeout
  useEffect(() => {
    if (inactiveTime >= timeoutValue) {
      // Only logout if user is logged in
      const ecauthtoken = localStorage?.getItem('ecauthtoken');
      const ecsecuretoken = localStorage?.getItem('ecsecuretoken');
      if (ecauthtoken && ecsecuretoken && location?.pathname?.startsWith('/admin')) {
        globalAlert("error", "Session expired due to inactivity");
        logOut(history, '/admin/login');
      }
    }
  }, [inactiveTime, timeoutValue]);
  return (
    <InactivityContext.Provider
      value={{
        timeoutValue,
        setTimeoutValue,
      }}
    >
      {children}
    </InactivityContext.Provider>
  );
};
